import map from 'lodash/map';
import cloneDeep from 'lodash/cloneDeep';
import DepsService from 'services/dependencies';

const createArrayFromSubscriptions = (subscriptions) =>
  map(subscriptions, (subscription) => {
    subscription.transformations = Object.keys(subscription.transformations).reduce((newTransformations, key) => {
      newTransformations = newTransformations.concat([subscription.transformations[key]]);
      return newTransformations;
    }, []);
    return subscription;
  });

export const getEmailListForRetailer = (retailerId, retailerType) =>
  DepsService.restSrv.list(undefined, DepsService.rest.account.report.email.subscriptions.url, {
    retailerId,
    retailerType,
  });

export const getReportListForRetailer = (retailerId, retailerType) =>
  DepsService.restSrv.list(undefined, DepsService.rest.account.report.report.subscriptions.url, {
    retailerId,
    retailerType,
  });

export const saveReportListForRetailer = (retailerId, subscriptionsReports) =>
  DepsService.restSrv.create(undefined, DepsService.rest.account.report.report.subscriptions.url, {
    retailerId,
    subscriptions: createArrayFromSubscriptions(cloneDeep(subscriptionsReports)),
  });

export const saveEmailListForRetailer = (retailerId, subscriptionsEmail, externalEmails) =>
  DepsService.restSrv.create(undefined, DepsService.rest.account.report.email.subscriptions.url, {
    retailerId,
    externalEmails,
    subscriptions: createArrayFromSubscriptions(cloneDeep(subscriptionsEmail)),
  });

export const getSftpListForRetailer = (retailerId, retailerType) =>
  DepsService.restSrv.list(undefined, DepsService.rest.account.report.sftp.subscriptions.url, {
    retailerId,
    retailerType,
  });

export const getSftpListForGroup = (groupId, retailerType) =>
  DepsService.restSrv.list(undefined, DepsService.rest.account.report.sftp.subscriptions.url, {
    groupId,
    retailerType,
  });

export const saveSftpListForRetailer = (retailerId, subscriptionsSftp) =>
  DepsService.restSrv.create(undefined, DepsService.rest.account.report.sftp.subscriptions.url, {
    retailerId,
    subscriptions: createArrayFromSubscriptions(cloneDeep(subscriptionsSftp)),
  });

export const saveSftpListForGroup = (groupId, subscriptionsSftp) =>
  DepsService.restSrv.create(undefined, DepsService.rest.account.report.sftp.subscriptions.url, {
    groupId,
    subscriptions: createArrayFromSubscriptions(cloneDeep(subscriptionsSftp)),
  });



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/resources/report-subscriptions-api.js